<template>
  <v-app>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-app-bar v-if="isLoggedIn && $route.path !== '/'" app color="primary">
      <div class="mx-auto">
        <v-btn text color="white" to="/about">{{ $t('nav.about') }}</v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    computed: {
      loading() {
        return this.$store.getters.loading;
      },

      isLoggedIn() {
        return this.$store.getters['session/isLoggedIn'];
      }
    },

    beforeMount() {
      this.$store.watch(() => {
        return this.$store.getters.referrer;
      }, (referrer) => {
        if (referrer.type === 'invitation') {
          let invitationId = this.$store.getters.invitationId;

          if (!invitationId) {
            this.$store.watch(() => {
              return this.$store.getters.invitationId;
            }, (id) => {
              invitationId = id;
              this.updateInvitation(invitationId);
            });
          } else {
            this.updateInvitation(invitationId);
          }
        }
      });
    },

    async mounted() {
      if (this.$appConfig.features.userManagement) {
        this.$db.sync('users');
      }
    },

    methods: {
      updateInvitation(invitationId) {
        this.$db.get(invitationId, {}, 'invites').then((doc) => {
          const user = this.$store.getters['session/getUser'];
          doc.members.push(user._id);

          this.$db.put(doc, {}, 'invites');
        });
      }
    }
  };
</script>

<style lang="scss">
  @import './assets/scss/app.scss';
</style>
